import { render, staticRenderFns } from "./forget-password.html?vue&type=template&id=076c6f8a&"
import script from "./forget-password.js?vue&type=script&lang=js&"
export * from "./forget-password.js?vue&type=script&lang=js&"
import style0 from "./forget-password.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports